import { useState } from "react";
import { Box, Grid, List, ListItemButton, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useLayout from "@/features/layout/useLayout";
import EastIcon from '@mui/icons-material/East';

const WidgetsTableOfContent = ({widgets, onItemClick}) => {
  const { isMobile } = useLayout();
  const [activeTOC, setActiveTOC] = useState(widgets[0].key);
  const onTabClick = (e, val) => {
    setActiveTOC(val);
    onItemClick(val)
  }

  return (isMobile 
    ? <MobileWidgetsTableOfContent activeTOC={activeTOC} onTabClick={onTabClick} widgets={widgets}/>
    : <DesktopWidgetsTableOfContent activeTOC={activeTOC} onTabClick={onTabClick} widgets={widgets} />
  )
}

const MobileWidgetsTableOfContent = ({activeTOC, onTabClick, widgets}) => {
  const { t } = useTranslation();
  return (
    <Grid 
      size={12}
      sx={{
        borderBottom: 1, 
        borderColor: 'divider',
        // position: 'sticky',
        // top: '65px',
        // zIndex: 2,
      }}
    >
      {
        <List>
          {
            widgets.map((widgetItem) => (
              <ListItemButton 
                sx={{
                  fontWeight: '300',
                  // border: '1px solid',
                  // borderColor: 'divider',
                  // padding: '8px',
                  // marginBottom: '4px',
                  mb: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => onTabClick(null, widgetItem.key)} 
                key={widgetItem.key}
              >
                <Typography 
                  variant="body1"
                  sx={{
                    
                  }}
                >{ t(widgetItem.translateKey) }</Typography>
                <EastIcon 
                  fontSize="small"
                  sx={{
                    color: 'text.secondary',
                  }}
                />
              </ListItemButton >
            ))
          }
        </List>
      } 
    </Grid>
  )
}

const DesktopWidgetsTableOfContent = ({activeTOC, onTabClick, widgets}) => {
  const { t } = useTranslation();
  return (
    <Grid 
      size={{
        xs:12,
        md:2,
      }}
      sx={{
        borderRight: 1, 
        borderColor: 'divider',
      }}
      >
      <Box sx={{ 
          position: 'sticky',
          top: '65px',
          zIndex: 2,
      }}>
        <Tabs 
          orientation='vertical'
          value={activeTOC} 
          onChange={onTabClick} 
          aria-label="basic tabs example"
        > 
          {
            widgets.map((widgetItem) => (
              <Tab 
                sx={{
                fontWeight: '300',
                alignItems: 'end',
                }}
                key={widgetItem.key}
                label={t(widgetItem.translateKey)} 
                value={widgetItem.key}
              />
            ))
          }
          </Tabs>
      </Box>
    </Grid>
  )
}
export default WidgetsTableOfContent;